import { z } from 'zod';

export const ApplicationInternalAccessSchema = z.object({
  applicationId: z.string(),
  twingateNetworkId: z.string().nullable(),
  twingateNetworkSlug: z.string().nullable(),
  internalAccessNetworkId: z.string().nullable().optional(),
  internalAccessNetworkSlug: z.string().nullable().optional(),
  transport: z.enum(['twingate', 'internal-access']).optional(),
  isBindingPersisted: z.boolean(),
});

export const ApplicationInternalAccessResponseSchema = z.object({
  internalAccess: ApplicationInternalAccessSchema.nullable(),
});

export const UpsertApplicationInternalAccessBodySchema = z.object({
  twingateNetworkId: z.string().nullable().optional(),
  internalAccessNetworkId: z.string().nullable().optional(),
});

export const InternalAccessCheckCodeSchema = z.enum([
  'NETWORK_CONFIGURED',
  'PROXY_DEPLOYMENT',
  'PROXY_HEALTH',
  'RESOURCE_RESOLVABLE',
  'CONNECTOR_ALIVE',
  'EGRESS_PROBE',
  'EGRESS_POD',
  'EGRESS_HEALTH',
  'ROUTE_RESOLVABLE',
]);

export const InternalAccessCheckSchema = z.object({
  code: InternalAccessCheckCodeSchema,
  status: z.enum(['pass', 'fail', 'skip']),
  message: z.string(),
  latencyMs: z.number().optional(),
});

export const TestApplicationInternalAccessBodySchema = z.object({
  targetUrl: z.url().optional(),
});

export const TestApplicationInternalAccessResponseSchema = z.discriminatedUnion(
  'status',
  [
    z.object({
      status: z.literal('success'),
      checks: z.array(InternalAccessCheckSchema),
    }),
    z.object({
      status: z.literal('failed'),
      checks: z.array(InternalAccessCheckSchema),
      primaryFailure: z.string(),
    }),
  ],
);
